/**
 * Footer Localization System
 * 183 countries from SKIMS with delivery/currency sync
 * Currency symbols use unicode escapes per CLAUDE.md rules
 */

const FOOTER_COUNTRIES = [
  { iso_code: 'AL', name: 'Albania', currency_code: 'ALL', currency_symbol: 'ALL' },
  { iso_code: 'DZ', name: 'Algeria', currency_code: 'DZD', currency_symbol: 'DZD' },
  { iso_code: 'AD', name: 'Andorra', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'AO', name: 'Angola', currency_code: 'AOA', currency_symbol: 'AOA' },
  { iso_code: 'AI', name: 'Anguilla', currency_code: 'XCD', currency_symbol: 'XCD' },
  { iso_code: 'AG', name: 'Antigua & Barbuda', currency_code: 'XCD', currency_symbol: 'XCD' },
  { iso_code: 'AR', name: 'Argentina', currency_code: 'ARS', currency_symbol: 'ARS' },
  { iso_code: 'AM', name: 'Armenia', currency_code: 'AMD', currency_symbol: 'AMD' },
  { iso_code: 'AW', name: 'Aruba', currency_code: 'AWG', currency_symbol: 'AWG' },
  { iso_code: 'AU', name: 'Australia', currency_code: 'AUD', currency_symbol: '\u0024' },
  { iso_code: 'AT', name: 'Austria', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'AZ', name: 'Azerbaijan', currency_code: 'AZN', currency_symbol: 'AZN' },
  { iso_code: 'BS', name: 'Bahamas', currency_code: 'BSD', currency_symbol: 'BSD' },
  { iso_code: 'BH', name: 'Bahrain', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'BD', name: 'Bangladesh', currency_code: 'BDT', currency_symbol: 'BDT' },
  { iso_code: 'BB', name: 'Barbados', currency_code: 'BBD', currency_symbol: 'BBD' },
  { iso_code: 'BE', name: 'Belgium', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'BZ', name: 'Belize', currency_code: 'BZD', currency_symbol: 'BZD' },
  { iso_code: 'BJ', name: 'Benin', currency_code: 'XOF', currency_symbol: 'XOF' },
  { iso_code: 'BO', name: 'Bolivia', currency_code: 'BOB', currency_symbol: 'BOB' },
  { iso_code: 'BA', name: 'Bosnia & Herzegovina', currency_code: 'BAM', currency_symbol: 'BAM' },
  { iso_code: 'BW', name: 'Botswana', currency_code: 'BWP', currency_symbol: 'BWP' },
  { iso_code: 'BR', name: 'Brazil', currency_code: 'BRL', currency_symbol: 'BRL' },
  { iso_code: 'VG', name: 'British Virgin Islands', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'BN', name: 'Brunei', currency_code: 'BND', currency_symbol: 'BND' },
  { iso_code: 'BG', name: 'Bulgaria', currency_code: 'BGN', currency_symbol: 'BGN' },
  { iso_code: 'BF', name: 'Burkina Faso', currency_code: 'XOF', currency_symbol: 'XOF' },
  { iso_code: 'KH', name: 'Cambodia', currency_code: 'KHR', currency_symbol: 'KHR' },
  { iso_code: 'CM', name: 'Cameroon', currency_code: 'XAF', currency_symbol: 'XAF' },
  { iso_code: 'CA', name: 'Canada', currency_code: 'CAD', currency_symbol: '\u0024' },
  { iso_code: 'CV', name: 'Cape Verde', currency_code: 'CVE', currency_symbol: 'CVE' },
  { iso_code: 'KY', name: 'Cayman Islands', currency_code: 'KYD', currency_symbol: 'KYD' },
  { iso_code: 'TD', name: 'Chad', currency_code: 'XAF', currency_symbol: 'XAF' },
  { iso_code: 'CL', name: 'Chile', currency_code: 'CLP', currency_symbol: 'CLP' },
  { iso_code: 'CN', name: 'China', currency_code: 'CNY', currency_symbol: '\u00A5' },
  { iso_code: 'CO', name: 'Colombia', currency_code: 'COP', currency_symbol: 'COP' },
  { iso_code: 'KM', name: 'Comoros', currency_code: 'KMF', currency_symbol: 'KMF' },
  { iso_code: 'CK', name: 'Cook Islands', currency_code: 'NZD', currency_symbol: '\u0024' },
  { iso_code: 'CR', name: 'Costa Rica', currency_code: 'CRC', currency_symbol: 'CRC' },
  { iso_code: 'HR', name: 'Croatia', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'CW', name: 'Cura\u00E7ao', currency_code: 'ANG', currency_symbol: 'ANG' },
  { iso_code: 'CY', name: 'Cyprus', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'CZ', name: 'Czechia', currency_code: 'CZK', currency_symbol: 'CZK' },
  { iso_code: 'DK', name: 'Denmark', currency_code: 'DKK', currency_symbol: 'DKK' },
  { iso_code: 'DJ', name: 'Djibouti', currency_code: 'DJF', currency_symbol: 'DJF' },
  { iso_code: 'DM', name: 'Dominica', currency_code: 'XCD', currency_symbol: 'XCD' },
  { iso_code: 'DO', name: 'Dominican Republic', currency_code: 'DOP', currency_symbol: 'DOP' },
  { iso_code: 'EC', name: 'Ecuador', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'EG', name: 'Egypt', currency_code: 'EGP', currency_symbol: 'EGP' },
  { iso_code: 'SV', name: 'El Salvador', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'EE', name: 'Estonia', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'SZ', name: 'Eswatini', currency_code: 'SZL', currency_symbol: 'SZL' },
  { iso_code: 'ET', name: 'Ethiopia', currency_code: 'ETB', currency_symbol: 'ETB' },
  { iso_code: 'FK', name: 'Falkland Islands', currency_code: 'FKP', currency_symbol: 'FKP' },
  { iso_code: 'FO', name: 'Faroe Islands', currency_code: 'DKK', currency_symbol: 'DKK' },
  { iso_code: 'FJ', name: 'Fiji', currency_code: 'FJD', currency_symbol: 'FJD' },
  { iso_code: 'FI', name: 'Finland', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'FR', name: 'France', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'GF', name: 'French Guiana', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'PF', name: 'French Polynesia', currency_code: 'XPF', currency_symbol: 'XPF' },
  { iso_code: 'GA', name: 'Gabon', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'GM', name: 'Gambia', currency_code: 'GMD', currency_symbol: 'GMD' },
  { iso_code: 'GE', name: 'Georgia', currency_code: 'GEL', currency_symbol: 'GEL' },
  { iso_code: 'DE', name: 'Germany', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'GH', name: 'Ghana', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'GI', name: 'Gibraltar', currency_code: 'GBP', currency_symbol: '\u00A3' },
  { iso_code: 'GR', name: 'Greece', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'GL', name: 'Greenland', currency_code: 'DKK', currency_symbol: 'DKK' },
  { iso_code: 'GD', name: 'Grenada', currency_code: 'XCD', currency_symbol: 'XCD' },
  { iso_code: 'GP', name: 'Guadeloupe', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'GT', name: 'Guatemala', currency_code: 'GTQ', currency_symbol: 'GTQ' },
  { iso_code: 'GG', name: 'Guernsey', currency_code: 'GBP', currency_symbol: '\u00A3' },
  { iso_code: 'GN', name: 'Guinea', currency_code: 'GNF', currency_symbol: 'GNF' },
  { iso_code: 'GW', name: 'Guinea-Bissau', currency_code: 'XOF', currency_symbol: 'XOF' },
  { iso_code: 'GY', name: 'Guyana', currency_code: 'GYD', currency_symbol: 'GYD' },
  { iso_code: 'HT', name: 'Haiti', currency_code: 'HTG', currency_symbol: 'HTG' },
  { iso_code: 'HN', name: 'Honduras', currency_code: 'HNL', currency_symbol: 'HNL' },
  { iso_code: 'HK', name: 'Hong Kong SAR', currency_code: 'HKD', currency_symbol: 'HKD' },
  { iso_code: 'HU', name: 'Hungary', currency_code: 'HUF', currency_symbol: 'HUF' },
  { iso_code: 'IS', name: 'Iceland', currency_code: 'ISK', currency_symbol: 'ISK' },
  { iso_code: 'IN', name: 'India', currency_code: 'INR', currency_symbol: '\u20B9' },
  { iso_code: 'ID', name: 'Indonesia', currency_code: 'IDR', currency_symbol: 'Rp' },
  { iso_code: 'IE', name: 'Ireland', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'IM', name: 'Isle of Man', currency_code: 'GBP', currency_symbol: '\u00A3' },
  { iso_code: 'IL', name: 'Israel', currency_code: 'ILS', currency_symbol: 'ILS' },
  { iso_code: 'IT', name: 'Italy', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'JM', name: 'Jamaica', currency_code: 'JMD', currency_symbol: 'JMD' },
  { iso_code: 'JP', name: 'Japan', currency_code: 'JPY', currency_symbol: '\u00A5' },
  { iso_code: 'KZ', name: 'Kazakhstan', currency_code: 'KZT', currency_symbol: 'KZT' },
  { iso_code: 'KE', name: 'Kenya', currency_code: 'KES', currency_symbol: 'KES' },
  { iso_code: 'KW', name: 'Kuwait', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'KG', name: 'Kyrgyzstan', currency_code: 'KGS', currency_symbol: 'KGS' },
  { iso_code: 'LA', name: 'Laos', currency_code: 'LAK', currency_symbol: 'LAK' },
  { iso_code: 'LV', name: 'Latvia', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'LB', name: 'Lebanon', currency_code: 'LBP', currency_symbol: 'LBP' },
  { iso_code: 'LS', name: 'Lesotho', currency_code: 'LSL', currency_symbol: 'LSL' },
  { iso_code: 'LI', name: 'Liechtenstein', currency_code: 'CHF', currency_symbol: 'CHF' },
  { iso_code: 'LT', name: 'Lithuania', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'LU', name: 'Luxembourg', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'MO', name: 'Macao SAR', currency_code: 'MOP', currency_symbol: 'MOP' },
  { iso_code: 'MW', name: 'Malawi', currency_code: 'MWK', currency_symbol: 'MWK' },
  { iso_code: 'MY', name: 'Malaysia', currency_code: 'MYR', currency_symbol: 'MYR' },
  { iso_code: 'MV', name: 'Maldives', currency_code: 'MVR', currency_symbol: 'MVR' },
  { iso_code: 'MT', name: 'Malta', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'MQ', name: 'Martinique', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'MU', name: 'Mauritius', currency_code: 'MUR', currency_symbol: 'MUR' },
  { iso_code: 'MX', name: 'Mexico', currency_code: 'MXN', currency_symbol: 'MXN' },
  { iso_code: 'MD', name: 'Moldova', currency_code: 'MDL', currency_symbol: 'MDL' },
  { iso_code: 'MC', name: 'Monaco', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'MN', name: 'Mongolia', currency_code: 'MNT', currency_symbol: 'MNT' },
  { iso_code: 'ME', name: 'Montenegro', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'MS', name: 'Montserrat', currency_code: 'XCD', currency_symbol: 'XCD' },
  { iso_code: 'MA', name: 'Morocco', currency_code: 'MAD', currency_symbol: 'MAD' },
  { iso_code: 'MZ', name: 'Mozambique', currency_code: 'MZN', currency_symbol: 'MZN' },
  { iso_code: 'NA', name: 'Namibia', currency_code: 'NAD', currency_symbol: 'NAD' },
  { iso_code: 'NR', name: 'Nauru', currency_code: 'AUD', currency_symbol: '\u0024' },
  { iso_code: 'NP', name: 'Nepal', currency_code: 'NPR', currency_symbol: 'NPR' },
  { iso_code: 'NL', name: 'Netherlands', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'NC', name: 'New Caledonia', currency_code: 'XPF', currency_symbol: 'XPF' },
  { iso_code: 'NZ', name: 'New Zealand', currency_code: 'NZD', currency_symbol: '\u0024' },
  { iso_code: 'NI', name: 'Nicaragua', currency_code: 'NIO', currency_symbol: 'NIO' },
  { iso_code: 'NG', name: 'Nigeria', currency_code: 'NGN', currency_symbol: 'NGN' },
  { iso_code: 'NU', name: 'Niue', currency_code: 'NZD', currency_symbol: '\u0024' },
  { iso_code: 'MK', name: 'North Macedonia', currency_code: 'MKD', currency_symbol: 'MKD' },
  { iso_code: 'NO', name: 'Norway', currency_code: 'NOK', currency_symbol: 'NOK' },
  { iso_code: 'OM', name: 'Oman', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'PK', name: 'Pakistan', currency_code: 'PKR', currency_symbol: 'PKR' },
  { iso_code: 'PA', name: 'Panama', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'PG', name: 'Papua New Guinea', currency_code: 'PGK', currency_symbol: 'PGK' },
  { iso_code: 'PY', name: 'Paraguay', currency_code: 'PYG', currency_symbol: 'PYG' },
  { iso_code: 'PE', name: 'Peru', currency_code: 'PEN', currency_symbol: 'PEN' },
  { iso_code: 'PH', name: 'Philippines', currency_code: 'PHP', currency_symbol: 'PHP' },
  { iso_code: 'PL', name: 'Poland', currency_code: 'PLN', currency_symbol: 'PLN' },
  { iso_code: 'PT', name: 'Portugal', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'QA', name: 'Qatar', currency_code: 'QAR', currency_symbol: 'QAR' },
  { iso_code: 'RE', name: 'R\u00E9union', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'RO', name: 'Romania', currency_code: 'RON', currency_symbol: 'RON' },
  { iso_code: 'RW', name: 'Rwanda', currency_code: 'RWF', currency_symbol: 'RWF' },
  { iso_code: 'SM', name: 'San Marino', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'ST', name: 'S\u00E3o Tom\u00E9 & Pr\u00EDncipe', currency_code: 'STD', currency_symbol: 'STD' },
  { iso_code: 'SA', name: 'Saudi Arabia', currency_code: 'SAR', currency_symbol: 'SAR' },
  { iso_code: 'SN', name: 'Senegal', currency_code: 'XOF', currency_symbol: 'XOF' },
  { iso_code: 'RS', name: 'Serbia', currency_code: 'RSD', currency_symbol: 'RSD' },
  { iso_code: 'SC', name: 'Seychelles', currency_code: 'SCR', currency_symbol: 'SCR' },
  { iso_code: 'SL', name: 'Sierra Leone', currency_code: 'SLL', currency_symbol: 'SLL' },
  { iso_code: 'SG', name: 'Singapore', currency_code: 'SGD', currency_symbol: '\u0024' },
  { iso_code: 'SK', name: 'Slovakia', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'SI', name: 'Slovenia', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'SB', name: 'Solomon Islands', currency_code: 'SBD', currency_symbol: 'SBD' },
  { iso_code: 'ZA', name: 'South Africa', currency_code: 'ZAR', currency_symbol: 'ZAR' },
  { iso_code: 'KR', name: 'South Korea', currency_code: 'KRW', currency_symbol: '\u20A9' },
  { iso_code: 'ES', name: 'Spain', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'LK', name: 'Sri Lanka', currency_code: 'LKR', currency_symbol: 'LKR' },
  { iso_code: 'BL', name: 'St. Barth\u00E9lemy', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'KN', name: 'St. Kitts & Nevis', currency_code: 'XCD', currency_symbol: 'XCD' },
  { iso_code: 'LC', name: 'St. Lucia', currency_code: 'XCD', currency_symbol: 'XCD' },
  { iso_code: 'MF', name: 'St. Martin', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'VC', name: 'St. Vincent & Grenadines', currency_code: 'XCD', currency_symbol: 'XCD' },
  { iso_code: 'SR', name: 'Suriname', currency_code: 'SRD', currency_symbol: 'SRD' },
  { iso_code: 'SE', name: 'Sweden', currency_code: 'SEK', currency_symbol: 'SEK' },
  { iso_code: 'CH', name: 'Switzerland', currency_code: 'CHF', currency_symbol: 'CHF' },
  { iso_code: 'TW', name: 'Taiwan', currency_code: 'TWD', currency_symbol: 'TWD' },
  { iso_code: 'TZ', name: 'Tanzania', currency_code: 'TZS', currency_symbol: 'TZS' },
  { iso_code: 'TH', name: 'Thailand', currency_code: 'THB', currency_symbol: '\u0E3F' },
  { iso_code: 'TL', name: 'Timor-Leste', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'TG', name: 'Togo', currency_code: 'XOF', currency_symbol: 'XOF' },
  { iso_code: 'TO', name: 'Tonga', currency_code: 'TOP', currency_symbol: 'TOP' },
  { iso_code: 'TT', name: 'Trinidad & Tobago', currency_code: 'TTD', currency_symbol: 'TTD' },
  { iso_code: 'TM', name: 'Turkmenistan', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'TC', name: 'Turks & Caicos Islands', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'TV', name: 'Tuvalu', currency_code: 'AUD', currency_symbol: '\u0024' },
  { iso_code: 'UG', name: 'Uganda', currency_code: 'UGX', currency_symbol: 'UGX' },
  { iso_code: 'AE', name: 'United Arab Emirates', currency_code: 'AED', currency_symbol: 'AED' },
  { iso_code: 'GB', name: 'United Kingdom', currency_code: 'GBP', currency_symbol: '\u00A3' },
  { iso_code: 'US', name: 'United States', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'UY', name: 'Uruguay', currency_code: 'UYU', currency_symbol: 'UYU' },
  { iso_code: 'UZ', name: 'Uzbekistan', currency_code: 'UZS', currency_symbol: 'UZS' },
  { iso_code: 'VU', name: 'Vanuatu', currency_code: 'VUV', currency_symbol: 'VUV' },
  { iso_code: 'VA', name: 'Vatican City', currency_code: 'EUR', currency_symbol: '\u20AC' },
  { iso_code: 'VE', name: 'Venezuela', currency_code: 'USD', currency_symbol: '\u0024' },
  { iso_code: 'VN', name: 'Vietnam', currency_code: 'VND', currency_symbol: '\u20AB' },
  { iso_code: 'WF', name: 'Wallis & Futuna', currency_code: 'XPF', currency_symbol: 'XPF' },
  { iso_code: 'ZM', name: 'Zambia', currency_code: 'ZMW', currency_symbol: 'ZMW' }
];

(function() {
  'use strict';

  var syncing = false;

  function initFooterLocalization() {
    var deliverySelect = document.getElementById('footer-delivery-select');
    var currencySelect = document.getElementById('footer-currency-select');

    if (!deliverySelect || !currencySelect) return;

    /* Currency dropdown: hooked to AnchorCurrency converter */
    function syncCurrencyToConverter() {
      if (!window.AnchorCurrency) return;
      var current = window.AnchorCurrency.get();
      currencySelect.value = current;
      deliverySelect.value = current === 'KRW' ? 'KR' : 'INTL';
    }

    syncCurrencyToConverter();

    currencySelect.addEventListener('change', function() {
      if (syncing) return;
      syncing = true;
      var val = currencySelect.value;
      if ((val === 'USD' || val === 'KRW') && window.AnchorCurrency) {
        window.AnchorCurrency.set(val);
        deliverySelect.value = val === 'KRW' ? 'KR' : 'INTL';
      }
      syncing = false;
    });

    deliverySelect.addEventListener('change', function() {
      if (syncing) return;
      syncing = true;
      var val = deliverySelect.value;
      var targetCurrency = val === 'KR' ? 'KRW' : 'USD';
      if (window.AnchorCurrency) {
        window.AnchorCurrency.set(targetCurrency);
        currencySelect.value = targetCurrency;
      }
      syncing = false;
    });

    document.addEventListener('anchor:currency-changed', syncCurrencyToConverter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterLocalization);
  } else {
    initFooterLocalization();
  }
})();
